const LogoMark = ({ className = "h-9 w-9", dark = false }) => (
  <svg
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M5 33 L12.5 20 L18.5 28.5 L24 13 L29.5 28.5 L35.5 20 L43 33"
      stroke={dark ? "#F6F2FF" : "#2B1B45"}
      strokeWidth="3"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
    <path
      d="M8 39.5 Q24 32 40 39.5"
      stroke="#F2644C"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export default LogoMark;
